// https://element-plus.org/zh-CN/
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
// rem换算
import "../../assets/main.css";
import "../../util/rem";
import "animate.css";

// 日期和时间本地化
import "dayjs/locale/zh-cn";

// https://animate.style/
// import 'animate.css';

// import '../../assets/main.css'

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueDOMPurifyHTML from "vue-dompurify-html";
import RaEventTrackerPlugin from "./../../util/tracker"; // 引入你创建的星辉统计插件

import * as Sentry from "@sentry/vue";

import { store } from "./store";

// faecbook插件SDK库
import { loadSdk } from "@/util/loadSdk";
loadSdk("fb", "zh_TW");

const app = createApp(App);

// 调试器
if (import.meta.env.DEV) {
  import("vconsole").then(({ default: VConsole }) => {
    new VConsole();
  });
}

Sentry.init({
  app,
  dsn: "https://51a676e58f740faa892d735ef27a1cde@o577525.ingest.us.sentry.io/4507674516783104",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

app.use(store);
app.use(router);
app.use(ElementPlus);
app.use(VueDOMPurifyHTML);
app.use(RaEventTrackerPlugin); // 使用星辉统计插件
app.mount("#app");
